<script setup lang="ts">
import { useProductPageStore } from "~/stores/main";

// -----------------------
// props
// -----------------------
const props = withDefaults(
  defineProps<{
    store?: any;
  }>(),
  {
    store: null,
  },
);

// -----------------------
// composables
// -----------------------
const store = props.store || useProductPageStore();
</script>

<template>
  <BreadcrumbBase :items="store.masterProduct?.calculated_cmspage_breadcrumb" />
</template>
